import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import { fetchLeadIntakeService, saveLeadIntakeService } from 'services/intakeforms/leadIntakeService';
import { convertObjectToQuery } from 'utils/utils';
import { postActivityLog } from 'services/generalServices';

export default function useLeadIntakeForm() {
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const location = useLocation();
  const { addToast } = useToast();

  const getClientIntake = () => {
    const token = new URLSearchParams(location.search).get('token');
    fetchLeadIntakeService(convertObjectToQuery({ token }))
      .then((response) => {
        setFormData(response?.data);
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const saveLeadIntake = (data) => {
    const token = new URLSearchParams(location.search).get('token');
    delete data?.recaptcha;
    saveLeadIntakeService(data, convertObjectToQuery({ token }))
      .then((response) => {
        setFormData(response?.data);
        addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.INTAKE_FORM_SUBMIT_SUCCESS);
        setIsSubmitted(true);
      })
      .catch((error) => {
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.INTAKE_FORM_SUBMIT_FAILED);
        logError(error, data);
        console.log('error', error);
      });
  };

  const logError = (error, formData) => {
    postActivityLog(
      {
        event_items: {
          error: JSON.stringify(error),
          data: formData,
          location: window.location.href,
        },
        event_type: 'lead_form_save_validation_error',
      },
      true
    );
  };

  useEffect(() => {
    getClientIntake();
  }, []);

  return { setIsSubmitted, saveLeadIntake, logError, formData, loading, isSubmitted };
}
